export default __webpack_public_path__ + "static/media/4_ShieldRecharge.23d34396.webp";